"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var Flag = function Flag(_ref) {
  var success = _ref.success,
      secondary = _ref.secondary,
      text = _ref.text;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)({
      'preact-flag': true,
      'preact-flag-success': success,
      'preact-flag-secondary': secondary
    })
  }, text);
};

var _default = Flag;
exports.default = _default;